module.exports = __webpack_public_path__ + "media/2.c7e92073.mp3";